//wordpress dependencies
const { __ } = wp.i18n;
const { useState, useEffect } = wp.element;
import { Spinner } from "@wordpress/components";
import axios from "axios";
import Qs from "qs";
import "./editor.scss";
import "./style.scss";
import Inspector from "./inspector";
import RenderView from "./renderView";
import $ from 'jquery';
import classnames from 'classnames';
import { CssGenerator } from "../../util/css/CssGenerator";

function Edit(props) {
	const { isSelected, attributes, setAttributes, clientId, className } = props;

	const { blockId } = attributes;
	const _client = clientId.substr(0, 6);
	useEffect(() => {
		if (!blockId) {
			setAttributes({ blockId: _client });
		} else if (blockId && blockId !== _client) {
			setAttributes({ blockId: _client });
		}
	}, []);

	const [listingsEffect, setListingsEffect] = useState(false);
	const listingsSideEffectChange = () => {
		setListingsEffect(!listingsEffect);
	}

	const [data, setData] = useState([]);
	const [dataSuccess, setDataSuccess] = useState(true);

	useEffect(() => {
		let ajaxdata = {
			action: 'rtcl_gb_listings_ajax',
			rtcl_nonce: rtcl_block_script.rtcl_nonce,
			attributes: attributes,
			offset: 0,
		}
		axios.post(rtcl_block_script.ajaxurl, Qs.stringify(ajaxdata))
			.then((response) => {
				if (response.data.success) {
					setData([...response.data.data.posts]);
					setDataSuccess(response.data.success)
				} else {
					setData([]);
					setDataSuccess(response.data.success)
				}
			})
			.catch((error) => console.log(error));
	}, [listingsEffect]);

	//Check if the post
	const hasPosts = Array.isArray(data) && data.length;
	if (!hasPosts) {
		return [
			isSelected && (
				<Inspector
					attributes={attributes}
					setAttributes={setAttributes}
					listingsSideEffectChange={listingsSideEffectChange}
				/>
			),
			dataSuccess ? (<div className="rtcl-gb-spinner"><Spinner /></div>) : (
				__('No posts found.', 'classified-listing')
			)
		];
	}

	//phone call click
	$(function () {
		$('.rtcl-gb-phone-reveal').on('click', function () {
			if ($(this).hasClass('not-revealed')) {
				$(this).removeClass('not-revealed').addClass('revealed');
				var phone = $(this).data('phone');
				$(this).find('span').text(phone);
			}
			return false;
		});
	});

	if (blockId) {
		CssGenerator(attributes, 'listing-ads-slider', blockId);
	}

	const MainWrapperClass = classnames([
		'rtcl-block-' + blockId,
		className,
		'rtcl-block-editor'
	]);

	//render
	return [
		isSelected && (
			<Inspector
				attributes={attributes}
				setAttributes={setAttributes}
				listingsSideEffectChange={listingsSideEffectChange}
			/>
		),

		<div className={MainWrapperClass}>
			<RenderView {...attributes} data={data} />
		</div>
	]
}

export default Edit;